// Unpublished Work © 2023 Deere & Company.

import t from 'tcomb';

export const TaxIdLogs = t.struct({
    govTaxId: t.String,
    iso2CntryCd: t.String,
    modifiedBy: t.String,
    remark: t.String,
    timeStamp: t.String,
    verified: t.String
}, {
    defaultProps: {
        govTaxId: '',
        iso2CntryCd: '',
        modifiedBy: '',
        remark: '',
        timeStamp: '',
        verified: ''
    },
    name: 'TaxIdLogs',
    strict: true
});
